import App from "./App";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Loader from "./utils/Loader";
const GlobalErrorFallback = ({ error, resetErrorBoundary }) => (
  <div style={{ padding: "40px", textAlign: "center", marginTop: "10%" }}>
    <h2>Oops! Something went wrong.</h2>
    <p style={{ color: "red" }}>{error.message}</p>
    <button
      onClick={() => window.location.reload()}
      className="btn btn-primary"
      style={{ padding: "10px 20px", cursor: "pointer" }}
    >
      Refresh Application
    </button>
  </div>
);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader size="large" />} persistor={persistor}>
      <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
      <ToastContainer />
    </PersistGate>
  </Provider>,
);
